module.exports = require("circular-dependency-plugin");